import { AppViewMode } from 'src/constants/uiConsts';
import { OnboardingLoginPage } from 'src/legacy/components/Onboarding/Login';
import { RouteAction } from 'src/routes/types';
import { getPublicImageURL } from 'src/utils/ImageUtils';

import { ClientLogin } from './ClientLogin';

const action: RouteAction = (context) => {
  const { isAssemblyDomain, query } = context;
  const isInternalUser = context.portalConfig.viewMode === AppViewMode.INTERNAL;

  const appTitle = isAssemblyDomain || isInternalUser ? 'Assembly' : 'Copilot';
  const socialShareImage = '/images/social-share.png';

  const { title, description } =
    query?.step === 'forgotPassword'
      ? {
          title: `${appTitle} • Forgot Password`,
          description: `Recover your password to log back in to your ${appTitle} account. `,
        }
      : {
          title: `${appTitle} • Log in`,
          description: `Log in to the ${appTitle} Dashboard to manage your business.`,
        };
  const prefetchUrls = isInternalUser
    ? []
    : [
        getPublicImageURL(
          context.portalConfig.assets.authImage.signInUrl || '',
          {
            resize: { width: 580 * 2, height: 580 * 2 },
          },
        ),
      ];
  return {
    chunks: ['login'],
    ...(isInternalUser ? { title, description, socialShareImage } : {}),
    component: isInternalUser ? <OnboardingLoginPage /> : <ClientLogin />,
    prefetchUrls,
  };
};

export default action;
